// Shared JS for all registration pages to reduce cache misses
// when navigating between pages.

// Rails assumes Turbolinks is always available, so it's easier to
// just make that true:
import Turbolinks from "turbolinks";
Turbolinks.start();
